import { Ghost } from '@/modules/customization/components/ghost/ghost';
import React from 'react';

interface ImagePreviewProps {
  width: number | `${number}%`;
  height: number | `${number}%`;
  fileUrl?: string | null;
  title: string;
}

export const ImagePreview: React.FC<ImagePreviewProps> = ({ width, height, fileUrl, title }) => {
  return fileUrl ? (
    <div
      style={{
        width,
        height,
        backgroundImage: `url(${fileUrl})`,
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'left center',
      }}
    />
  ) : (
    <Ghost width={width} height={height} title={title} />
  );
};
